'use client';

import { ComponentPropsWithoutRef, useState } from 'react';
import { Select } from '@/shared/ui/select';
import { MultiSelectContext } from './multi-select-context';
import { MultiSelectItem } from './multi-select-item';
import { MultiSelectValues } from './multi-select-values';

type Props = Omit<ComponentPropsWithoutRef<typeof Select>, 'onValueChange' | 'value' | 'defaultValue'> & {
    defaultValues?: string[];
    onValuesChange?: (values: string[]) => void;
    values?: string[];
};
const MultiSelectRoot = ({
    children,
    defaultValues,
    onValuesChange,
    values: externalValues,
    ...props
}: Props) => {
    const [values, setValues] = useState<string[]>(defaultValues ?? []);

    const toggleValue = (val: string) => {
        setValues((prev) => {
            if (prev.includes(val)) {
                const newValues = prev.filter((v) => v !== val);
                onValuesChange?.(newValues);
                return newValues;
            }
            const newValues = [...prev, val];
            onValuesChange?.(newValues);
            return newValues;
        });
    };

    return (
        <Select
            // Value must be set to "" to allow multiple selections
            value=""
            onValueChange={toggleValue}
            {...props}
        >
            <MultiSelectContext.Provider value={{ values: externalValues ?? values }}>
                {children}
            </MultiSelectContext.Provider>
        </Select>
    );
};

export const MultiSelect = Object.assign(MultiSelectRoot, {
    Item: MultiSelectItem,
    Trigger: Select.Trigger,
    Content: Select.Content,
    Values: MultiSelectValues,
});
